import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import moment from 'moment';
import { Observable, debounceTime, filter, merge, of, startWith, switchMap, tap } from 'rxjs';
import { Metadata } from 'src/app/shared/models/common-model';
import { PermissionsService, RolesParameter } from 'src/app/shared/services/permissions.service';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.css']
})
export class RolesListComponent implements OnInit {

  roleList$: Observable<any> = of([]);
  userTypes$: Observable<any> = of([]);

  roleFilterForm = new FormGroup({
    organizationId: new FormControl(0),
    hospitalId: new FormControl(0),
    pageSize: new FormControl(100),
    pageNumber: new FormControl(1),
    sortByAscending: new FormControl(false),
    orderBy: new FormControl('id'),
    searchKeyword: new FormControl(''),
    fromDate: new FormControl(new Date(moment().subtract(2, 'w').format('MM/DD/YYYY'))),
    toDate: new FormControl(new Date(moment().format('MM/DD/YYYY'))),
    // userType: new FormControl(1),
  });

  showloading = true;
  metaData = new Metadata();
  displayedColumns: Array<any> = [
    { displayName: 'Role Name', key: 'name', class: '', width: '100%', },
  ];

  private _mapDate(obj: RolesParameter): RolesParameter {
    return {...obj,
      fromDate: new Date(obj.fromDate).toLocaleDateString('en-US'),
      toDate: new Date(obj.toDate).toLocaleDateString('en-US'),
    };
  }

  constructor(
    private permissionsSrv: PermissionsService,
    private router: Router,
    private actRoute: ActivatedRoute
  ) {
    this.roleList$ = merge(
      this.router.events.pipe(
        filter(event => (event instanceof NavigationEnd)),
        tap( x => (this.showloading = true)),
        switchMap(ev => this.permissionsSrv.getRoles(this._mapDate(this.roleFilterForm.value) as RolesParameter).pipe( tap(x => this.showloading = false)) )
      ),
      this.roleFilterForm.valueChanges.pipe(
        debounceTime(100),
        tap( x => (this.showloading = true)),
        switchMap( formVal => this.permissionsSrv.getRoles(this._mapDate(formVal)).pipe( tap(x => this.showloading = false)) ),
      )
    ).pipe(
      startWith([])
    );
  }

  ngOnInit(): void {
    this.userTypes$ = this.permissionsSrv.getUserTypes();
    setTimeout(() => {
      this.roleFilterForm.patchValue({}, {emitEvent: true})
    });
  }




  onTableActionLinkClick(event) {
    this.router.navigate([event.data.id], {relativeTo: this.actRoute});
  }

  nextPage() {

  }

}
